import * as tslib_1 from "tslib";
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { Menu, Badge, Icon } from '@h3/antd-vue';
import * as WorkflowCenterNS from '../typings/workflow-center';
// 引入流程中心store
import WorkflowCenterStore from '../store/workflow-center';
let WorkflowCenterMenu = class WorkflowCenterMenu extends Vue {
    constructor() {
        super(...arguments);
        this.selectedKeys = [];
        this.specStyle = true;
    }
    get outwardType() {
        return this.$store.state.outwardType || 'light';
    }
    ondragWidthChange(v) {
        if (v > 190) {
            this.specStyle = true;
        }
        else {
            this.specStyle = false;
        }
    }
    get unFinishedListCount() {
        return this.$store && this.$store.state.WorkflowCenterStore.unFinishedListCount || 0;
    }
    get unReadListCount() {
        return this.$store && this.$store.state.WorkflowCenterStore.unReadListCount || 0;
    }
    get admin() {
        return this.$store && this.$store.state.System.System.admin; // 引入系统store的字段 
    }
    get rootAdmin() {
        return this.$store && this.$store.state.System.System.isRootAdmin;
    }
    onAdminChange(val) {
        // console.log('admin change: ', val);
        this.setSelectedKeys();
    }
    routeChange() {
        this.setSelectedKeys();
    }
    created() {
        // 动态注册模块
        this.$store && this.$store.registerModule('WorkflowCenterStore', WorkflowCenterStore);
    }
    beforeMount() {
        this.setSelectedKeys();
        this.handleGetWorkCount();
    }
    // 根据当前路由判断当前选中
    setSelectedKeys() {
        let { name } = this.$route;
        if (!name)
            return;
        if (!this.admin && ['queryInstance', 'queryParticipantWorkItem'].includes(name)) {
            name = 'myUnfinishedWorkItem';
        }
        name = name.substring(0, 1).toUpperCase() + name.substring(1);
        let skey = 0;
        switch (name) {
            case 'MyUnfinishedWorkItem':
                skey = WorkflowCenterNS.SelectKeysMapping.MyUnfinishedWorkItem;
                break;
            case 'MyUnReadWorkItem':
                skey = WorkflowCenterNS.SelectKeysMapping.MyUnReadWorkItem;
                break;
            case 'MyFinishedWorkItem':
                skey = WorkflowCenterNS.SelectKeysMapping.MyFinishedWorkItem;
                break;
            case 'MyReadWorkItem':
                skey = WorkflowCenterNS.SelectKeysMapping.MyReadWorkItem;
                break;
            case 'MyWorkflow':
                skey = WorkflowCenterNS.SelectKeysMapping.MyWorkflow;
                break;
            case 'QueryInstance':
                skey = WorkflowCenterNS.SelectKeysMapping.QueryInstance;
                break;
            case 'QueryParticipantWorkItem':
                skey = WorkflowCenterNS.SelectKeysMapping.QueryParticipantWorkItem;
                break;
            // case 'MyComments':
            //   skey = WorkflowCenterNS.SelectKeysMapping.MyComments;
            //   break;
            case 'DelegationWorkflow':
                skey = WorkflowCenterNS.SelectKeysMapping.DelegationWorkflow;
                break;
            default:
                skey = -1;
                break;
        }
        const _k = skey.toString();
        this.selectedKeys = [_k];
    }
    // 获取任务数
    handleGetWorkCount() {
        this.$store.dispatch('WorkflowCenterStore/getWorkCount');
    }
    destroyed() {
        this.$store.unregisterModule('WorkflowCenterStore');
    }
};
tslib_1.__decorate([
    Prop(Number)
], WorkflowCenterMenu.prototype, "dragWidth", void 0);
tslib_1.__decorate([
    Watch('dragWidth')
], WorkflowCenterMenu.prototype, "ondragWidthChange", null);
tslib_1.__decorate([
    Watch('admin')
], WorkflowCenterMenu.prototype, "onAdminChange", null);
tslib_1.__decorate([
    Watch('$route')
], WorkflowCenterMenu.prototype, "routeChange", null);
WorkflowCenterMenu = tslib_1.__decorate([
    Component({
        name: 'WorkflowCenterMenu',
        components: {
            AMenu: Menu,
            AMenuItem: Menu.Item,
            ASubMenu: Menu.SubMenu,
            ABadge: Badge,
            AIcon: Icon,
        }
    })
], WorkflowCenterMenu);
export default WorkflowCenterMenu;
